<template>
  <div :class="classItem">
    <img :src="src" />
    <div :class="item_tag">
      <a-tag color="#EDEEF0">カテゴリ名 </a-tag>
      <div class="text-epip mt-2 font-bold">
        メニュー概要がはいります。メニュー概要がはいります。メニュー概要がはいります。メニュー概要がはいります。メニュー概要が
      </div>
      <div :class="['text-epip mt-2', type]">
        メニュー概要がはいります。メニュー概要がはいります。メニュー概要がはいります。ュー概要がはいります。メニュー概要がはいります。ュー概要がはいります。メニュー概要がはいります。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: ['img_size', 'type', 'tag_hidden', 'item_tag', 'src', 'classItem']
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
.ant-tag {
  color: #222222;
  font-size: 10px;
  padding: 2.5px 8px;
  @apply mt-2;
}
</style>